import styles from "./assets/scss/page-container.module.css";
import { IProps } from "./interface/page-container";

const PageContainer = ({ children }: IProps) => {
  return <>{children}</>;
};

export default PageContainer;
